import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import poemReducer from './poemSlice';
import narrativeReducer from './narrativeSlice';
import bookReducer from './bookSlice';
import coursesReducer from './coursesSlice';
import termsAndConditionsReducer from './termsAndConditionsSlice';
 import aboutUsReducer from './aboutUsSlice';
import aboutMeReducer from './aboutMeSlice';
import privacyPolicyReducer from './privacyPolicySlice';
import suggestionsReducer from './suggestionsSlice';
import suggestReducer from './suggestSlice';
import notificationReducer from './notificationSlice';
import thoughtReducer from './thoughtSlice';
const store = configureStore({
  reducer: {
    auth: authReducer,
    poems: poemReducer,
    narratives: narrativeReducer,
    book: bookReducer,
    courses: coursesReducer,
    termsAndConditions: termsAndConditionsReducer,
    aboutUs: aboutUsReducer,
   aboutMe: aboutMeReducer,
   privacyPolicy: privacyPolicyReducer,
   suggestions: suggestionsReducer,
   suggest: suggestReducer,
   notifications: notificationReducer, 
   thought: thoughtReducer
    },
});

export default store;